export default {
    manage_cameraManagement: "Administración de Cámaras",
    manage_cameraManagement_title: "Administración de Cámaras",
    manage_cameraManagement_recordId: "Id del Registro",
    manage_cameraManagement_imei: "IMEI",
    manage_cameraManagement_esn: "ESN",
    manage_cameraManagement_pairedUnit: "Unidad Emparejada",
    manage_cameraManagement_label: "Etiqueta",
    manage_cameraManagement_unpaired: "No emparejado",
    manage_cameraManagement_editCameraPairing: "Editar emparejamiento de la cámara",
    manage_cameraManagement_showUnpairedOnly: "Mostrar sólo no emparejados",
    manage_cameraManagement_editCamera: "Editar",
    manage_cameraManagement_cameraSetup: "Configuración de la Cámara",
    manage_cameraManagement_sdCardError: "Error de tarjeta SD",
    manage_cameraManagement_warnings: "Advertencias",
    manage_cameraManagement_bulk_camera_config: "Configuración masiva de las cámaras",
    manage_cameraManagement_device_model: "Modelo del Dispositivo",
    manage_cameraManagement_4K: "VidFleet AI+",
    manage_cameraManagement_360: "VidFleet 1",
    manage_cameraManagement_same_device_model: "El modelo de dispositivo de las cámaras debe ser el mismo",
    manage_cameraManagement_cameras_must_be_vidfleet: "Las cámaras deben ser VidFleet",
    manage_cameraManagement_camara_as_gps: "Cámara como GPS",
    manage_cameraManagement_search_by_label_imei_esn: "Buscar por Etiqueta, Unidad Emparejada o ESN",
};